import { useCallback } from 'react'
import Box from '@mui/material/Box'

const ShareCodeInput = ({
  shareLink,
  onChange,
  placeholder = 'e.g. https://www.reclip.app/r/12345678',
}) => {
  const handleChange = useCallback(
    (e) => {
      onChange(e.target.value)
    },
    [onChange]
  )

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        '& input': {
          flex: 1,
          border: 0,
          outline: 0,
          backgroundColor: 'transparent',
          color: 'text.primary',
          fontSize: '20px',
          borderWidth: 1,
          borderColor: 'divider',
          borderStyle: 'solid',
          p: 1.5,
          borderRadius: 2,
        },
      }}
    >
      <input
        type="text"
        value={shareLink}
        onChange={handleChange}
        placeholder={placeholder}
        spellCheck={false}
      />
    </Box>
  )
}

export default ShareCodeInput
